export default function isAtStartOfBlock(editor) {
  var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : editor.value.startBlock;
  return editor.value.selection.isCollapsed && editor.value.selection.start.isAtStartOfNode(block);
}